// extracted by mini-css-extract-plugin
module.exports = {"triangle-down-right":"styles-module__triangle-down-right___3h3SP","shareContainer":"styles-module__shareContainer___3RXrw"};